/* tslint:disable */
import * as Types from '../../../../../../graphql-api/gql-api-interfaces';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type BasketAccountsQueryVariables = Types.Exact<{
  basketId: Types.Scalars['String']['input'];
}>;


export type BasketAccountsQuery = { basketAccounts: Array<{ accountId: string, externalId: string, name: string, domainId?: string | null, shipToAddresses: Array<{ accountId: string, addressId: string, realAddressId?: string | null, name: string, state?: string | null, street?: string | null, city?: string | null, country: string, hasDeliveryItems?: boolean | null, deletedAtUtc?: string | null }> }> };

export const BasketAccountsDocument = gql`
    query basketAccounts($basketId: String!) {
  basketAccounts(basketId: $basketId) {
    accountId
    externalId
    name
    domainId
    shipToAddresses {
      accountId
      addressId
      realAddressId
      name
      state
      street
      city
      country
      hasDeliveryItems
      deletedAtUtc
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BasketAccountsGQL extends Apollo.Query<BasketAccountsQuery, BasketAccountsQueryVariables> {
    document = BasketAccountsDocument;
    client = 'accounts';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }